import React, { FC } from 'react';
import { Typography, TypographyTagVariants } from '@components/atoms/Typography';
import { Card } from '@components/atoms/Card';
import styles from './ResumedStatisticCard.module.css';

export interface ResumedStatisticCardProps {
    icon: string;
    description: string;
    value: string | number;
}

export const ResumedStatisticCard: FC<ResumedStatisticCardProps> = ({ icon, description, value }) => {
    return (
        <Card classes={styles['statistic-card']}>
            <div className="card-body text-center py-4 px-3 px-md-1 m-md-2">
                <Typography color="primary">
                    <i className={`${icon} mt-1 mb-4`}></i>
                </Typography>
                <Card.Title
                    typography={{
                        tagVariant: TypographyTagVariants.h5,
                        classes: 'text-truncate mt-1 mb-3',
                        fontWeight: '400',
                        fontSize: '16',
                        breakpointsStyles: { md: { fontSize: '20' } },
                        children: description,
                    }}
                />
                <Typography classes="text-truncate lh-1 pt-1 mb-1" fontWeight="800" fontSize="40">
                    {`${value}`}
                </Typography>
            </div>
        </Card>
    );
};
